import { render, staticRenderFns } from "./Teaching.vue?vue&type=template&id=7d099861&scoped=true"
import script from "./Teaching.vue?vue&type=script&lang=js"
export * from "./Teaching.vue?vue&type=script&lang=js"
import style0 from "./Teaching.vue?vue&type=style&index=0&id=7d099861&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d099861",
  null
  
)

export default component.exports